import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"

// Account/PaymentMethods/PaymentMethod's vocabulary, minus the account-only bits.
const GuestCapturedPaymentMethod = ({ paymentMethod, dispatch, copy }) => {
  return (
    <div className="flex items-center justify-between rounded border p-3.5 drop-shadow-sm">
      <div className="flex items-center">
        {paymentMethod.logo && (
          <img
            src={paymentMethod.logo}
            alt="payment method brand logo"
            className="mr-4 w-8"
          />
        )}
        <div className="flex flex-col">
          <h5 className="m-0 text-sm font-semibold">
            {paymentMethod.title || copy.paymentMethodAdded}
          </h5>
          {paymentMethod.subtitle && (
            <span className="text-xs text-gray-600">
              {paymentMethod.subtitle}
            </span>
          )}
        </div>
      </div>
      <Button
        variant="tertiary"
        onClick={() =>
          dispatch({ type: "PAYMENT_METHOD_SELECTED", payload: "add" })
        }
      >
        {copy.useDifferentPaymentMethod}
      </Button>
    </div>
  )
}

GuestCapturedPaymentMethod.propTypes = {
  paymentMethod: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    logo: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    paymentMethodAdded: PropTypes.string.isRequired,
    useDifferentPaymentMethod: PropTypes.string.isRequired,
  }).isRequired,
}

export default GuestCapturedPaymentMethod
